import { immerable } from "immer"
import { useState } from 'react'
import api from '@/services/api/twoFactorAuthenticatication.js'

class TwoFactorSecret {

	[immerable] = true

	constructor(params) {
		this.secret = params.secret
		this.qr = params.qr
	}
}

const useTwoFactorAuthentincation = () => {

	const [currentItemTwoFactorAuthentication ,setCurrentItemTwoFactorAuthentication] = useState(null)
	const [loadingTwoFactorAuthentication, setLoadingTwoFactorAuthentication] = useState(false)
	const [errorTwoFactorAuthentication, setErrorTwoFactorAuthentication] = useState()

	async function fetchTwoFactorAuthentication() {

		setLoadingTwoFactorAuthentication(true)

		const [error, data] = await api.generateTfa()

		setLoadingTwoFactorAuthentication(false)

		if (error) {
			return setErrorTwoFactorAuthentication('Two Factor Authenticate API has error')
		}

		const serializedData = serialize(data)
		const newItems = new TwoFactorSecret(serializedData)
		return setCurrentItemTwoFactorAuthentication(newItems)
	}

	function serialize(entry) {
		return {
			secret: entry.secret,
			qr: entry.qrcode,
		}
	}

	return {
		errorTwoFactorAuthentication,
		fetchTwoFactorAuthentication,
		currentItemTwoFactorAuthentication,
		setCurrentItemTwoFactorAuthentication,
		loadingTwoFactorAuthentication
	}

}

export default useTwoFactorAuthentincation
